export enum InfluencerFilterSelectionEnum {
  SELECTED = 'selected',
  UNSELECTED = 'unselected',
}

export enum InfluencerFilterYesNoEnum {
  YES = 'yes',
  NO = 'no',
}
